class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.promotionsRefresh();
    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.get('utm-content') === 'product-card-atc') {
      this.open();
      urlParams.delete('utm-content');
      const newQueryString = urlParams.toString();
      const newUrl = newQueryString ? `${window.location.pathname}?${newQueryString}` : window.location.pathname;
      window.history.replaceState(null, '', newUrl);
    }
  }

  cartPromotionsUnsubscriber = undefined;

  connectedCallback() {
    this.cartPromotionsUnsubscriber = subscribe(PUB_SUB_EVENTS.cartPromotionsRefresh, this.promotionsRefresh);
  }

  disconnectedCallback() {
    if (this.cartPromotionsUnsubscriber) this.cartPromotionsUnsubscriber();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');

    if(!triggeredBy){
      const wait= (this.classList.contains('processing--after') || this.classList.contains('processing')) ? 250 : 1000;
      this.classList.add('processing');
      setTimeout(() => { this.classList.remove('processing') }, wait);
    }
  }

  close() {
    if(this.classList.contains('processing') || this.classList.contains('processing--after')) return;
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, silent = false) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(section.id === "cart-drawer"){
        const sourceElement= new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html').querySelector(section.selector || '.shopify-section');
        const CartDrawer = document.querySelector('cart-drawer');
        const sezzleArtifacts = {
          index: CartDrawer.querySelector('[data-sezzleindex]'),
          button: CartDrawer.querySelector('.sezzle-shopify-info-button'),
          buttonPreviousSibling: CartDrawer.querySelector('.sezzle-shopify-info-button')?.previousElementSibling,
        };

        sectionElement.innerHTML = sourceElement.innerHTML;

        if (sezzleArtifacts.index && sezzleArtifacts.button) {
          const updatedSectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);

          const destinationPriceDescendent = updatedSectionElement.querySelector(`.${sezzleArtifacts.index.className.split(' ').join('.')}`);
          if (destinationPriceDescendent) destinationPriceDescendent.setAttribute('data-sezzleindex', sezzleArtifacts.index.getAttribute('data-sezzleindex'));

          if(sezzleArtifacts.buttonPreviousSibling){
            const buttonLocation = updatedSectionElement.querySelector(`.${sezzleArtifacts.buttonPreviousSibling.className.split(' ').join('.')}`);
            if (buttonLocation) buttonLocation.insertAdjacentElement('afterend', sezzleArtifacts.button);
          }
        }
        document.body.dispatchEvent(new CustomEvent('cart:updated'));
        return;
      }
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (!silent) {
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  promotionsRefresh = (event) => {
    if(event && event.source && event.source === 'promotion-variant-change'){
      this.promotionVariantChange(event);
      return;
    };

    if(event && event.source && event.source === 'promotion-variant-choice'){
      this.promotionVariantChoice(event);
      return;
    };

    if(event && event.source && event.source === 'promotion-variant-default'){
      this.promotionVariantDefault(event);
      return;
    };

    const config = fetchConfig('javascript');
    const cartPromotions = document.querySelector('.cart__promotions > script');
    if(cartPromotions) {
      let _this = this;
      fetch(`${window.routes.cart_url}.js`).then((response) => response.json()).then((cart) => {
        _this.cart = cart;
        _this.cartPromotions = JSON.parse(cartPromotions.innerHTML);

        const requests= [];
        const rules= _this.cartPromotions.rules.filter(rule => (rule.product.available || ( rule.fake_product && rule.fake_product.available )));
        if(rules.length > 0) for(const rule of rules) {
          var target_amount = rule.amount * 100;
          const items_subtotal_price= _this.cart.items_subtotal_price - _this.cart.items.filter(item => item.gift_card).reduce((acc, item) => acc + item.final_line_price, 0);
          if(rule.fake_product){
            const applied_rule= _this.cart.items.find(item => item.product_id === rule.fake_product.id && item.properties._automatic_promotion === rule.title);
            if(items_subtotal_price >= target_amount && !applied_rule){
              const availableVariants= rule.fake_product.variants.filter(variant => variant.available);
              if (availableVariants.length == 1) requests.push({ route: window.routes.cart_add_url, body: { id: availableVariants[0].id, quantity: 1, properties: { _automatic_promotion: rule.title } } });
            }else if(items_subtotal_price < target_amount && applied_rule) requests.push({ route: window.routes.cart_update_url, body: { key: applied_rule.key, quantity: 0 } });
          }else{
            const applied_rule= _this.cart.items.find(item => item.product_id === rule.product.id && item.properties._automatic_promotion == rule.title);
            const rule_offset= _this.cart.items.find(item => item.product_id === rule.product.id && item.properties._automatic_promotion != rule.title)
            if(rule_offset) target_amount += rule_offset.price;
            if(items_subtotal_price >= target_amount) {
              if(!applied_rule && _this.cart.total_discount < rule.product.price) {
                const availableVariants= rule.product.variants.filter(variant => variant.available);
                if (availableVariants.length == 1) requests.push({ route: window.routes.cart_add_url, body: { id: availableVariants[0].id, quantity: 1, properties: { _automatic_promotion: rule.title } } });
              }else if(applied_rule && _this.cart.total_discount > rule.product.price) requests.push({ route: window.routes.cart_update_url, body: { key: applied_rule.key, quantity: 0 } });
            }else if(applied_rule) requests.push({ route: window.routes.cart_update_url, body: { key: applied_rule.key, quantity: 0 } });
          }
        }

        const productRules= _this.cartPromotions.productDiscounts.filter(rule => rule);
        if(productRules.length > 0){
          const productRulesGifted= productRules.filter(rule => rule.type === "gift");
          const productRulesDiscounted= productRules.filter(rule => rule.type === "discount");
          for(const productRule of productRulesGifted){
            const applied_rule= _this.cart.items.find(item => item.product_id === productRule.product.id && item.properties._automatic_promotion === productRule.title);
            if(applied_rule){
              const triggerProduct= _this.cart.items.find(item => item.product_id === productRule.triggerProduct?.id);
              if(!triggerProduct) requests.push({ route: window.routes.cart_update_url, body: { key: applied_rule.key, quantity: 0 } });
            }
          }
        }

        const persistingTemplate= window.localStorage.getItem("announcement_bar_persist");
        if(persistingTemplate){
          if(_this.cartPromotions.coupons && _this.cartPromotions.coupons.length > 0){
            const availableCouponCode= _this.cartPromotions.coupons.find(coupon => coupon.template == persistingTemplate);
            if(availableCouponCode){
              const alreadyApplied= _this.cart.cart_level_discount_applications.find(discount => discount.title.toLowerCase() === availableCouponCode.code.toLowerCase());
              if(!alreadyApplied && _this.cart.items.length > 0) requests.push({ route: window.routes.discount_add_url, body: { code: availableCouponCode.code } });
            }
          }

          if(!_this.cart.attributes["_announcement_bar"] || _this.cart.attributes["_announcement_bar"] !== persistingTemplate){
            const formData = new FormData();
            formData.append("attributes[_announcement_bar]", persistingTemplate);
            fetch(window.shopUrl + '/cart/update.js', { method: 'POST', body: formData })
          }
        }

        if(requests.length > 0){
          const allRequests= [];
          const updateRequest= requests.filter(request => request.route === window.routes.cart_update_url);
          const addRequests= requests.filter(request => request.route === window.routes.cart_add_url);
          const discountRequest= requests.filter(request => request.route === window.routes.discount_add_url);

          if(updateRequest.length > 0){
            const updates= {}
            for(const request of updateRequest) updates[request.body.key]= request.body.quantity;
            allRequests.push(fetch(window.routes.cart_update_url, {
              body: JSON.stringify({updates}),
              ...config
            }));
          }

          if(addRequests.length > 0){
            const items= addRequests.map(request => request.body);
            allRequests.push(fetch(window.routes.cart_add_url, {
              body: JSON.stringify({items}),
              ...config
            }));
          }

          if(discountRequest.length > 0){
            allRequests.push(fetch(`${window.routes.discount_add_url}/${discountRequest[0].body.code}`));
          }

          Promise.all(allRequests).then(async () => {
            if(event && event.source){
              publish(PUB_SUB_EVENTS.cartUpdate, { ...event, force: true });
            }else{
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-promotions' });
            }
          }).catch((error) => {
            console.error("Error updating cart promotions", error);
          });
        }else{
          if(event && event.source){
            publish(PUB_SUB_EVENTS.cartUpdate, { ...event, force: true });
          }else{
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-promotions' });
          }
        }
      });
    }else if(event && event.source){
      publish(PUB_SUB_EVENTS.cartUpdate, event);
    }
  }

  promotionVariantChange = (event) => {
    const cartPromotions = document.querySelector('.cart__promotions > script');
    if(!cartPromotions) return;

    const cartPromotionsJson= JSON.parse(cartPromotions.innerHTML);
    const rule= cartPromotionsJson.rules.find(rule => ( rule.product.variants.find(variant => String(variant.id) == event.value) || (rule.fake_product && rule.fake_product.variants.find(variant => String(variant.id) == event.value)) ));
    if(!rule) return;

    let selectedProduct= rule.product;
    if(rule.fake_product) selectedProduct= rule.fake_product;
    const selectedVariant= selectedProduct.variants.find(variant => String(variant.id) == event.value);
    const variantImageElement= this.querySelector('.cart__promotions .cart-item__media img');
    if(variantImageElement) variantImageElement.src= selectedVariant.featured_image.src;
  }

  promotionVariantChoice = (event) => {
    const config = fetchConfig('javascript');
    const cartPromotions = document.querySelector('.cart__promotions > script');
    event.target.disabled= true;
    event.target.classList.add('loading');
    const selectedVariant= event.target.parentElement.querySelector("select").value;
    if(cartPromotions && selectedVariant){
      const cartPromotionsJson= JSON.parse(cartPromotions.innerHTML);
      const rule= cartPromotionsJson.rules.find(rule => ( rule.product.variants.find(variant => String(variant.id) == selectedVariant) || (rule.fake_product && rule.fake_product.variants.find(variant => String(variant.id) == selectedVariant)) ));
      fetch(window.routes.cart_add_url, { ...config, body: JSON.stringify({ id: selectedVariant, quantity: 1, properties: { _automatic_promotion: rule.title } }) })
      .then(function (cart) { cart.json() }).then(function (cart) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-promotions', force: true });
      })
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
